export default {"src":"/_next/static/media/checkmark-pink.2236d2d5.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};